import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy, APP_BASE_HREF } from '@angular/common';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/auth/auth.service';
import { NavbarService } from './core/navbar/navbar.service';
import { ProfileService } from './core/auth/profile.service';
import { WindowRef } from './core/domain/window-ref';
import { DomService } from './core/dom/dom.service';
import { PATH } from './const/path';

@Component({
    selector: 'admin-root',
    providers: [Location, { provide: APP_BASE_HREF, useValue: '/' }, { provide: LocationStrategy, useClass: PathLocationStrategy }],
    templateUrl: './app.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {

  private defaultTranslation$ = new Subscription();
  private profile$ = new Subscription();
  private readonly config$ = new Subscription();
  private userTranslation$ = new Subscription();


  constructor(private readonly location: Location, private readonly auth: AuthService, private readonly dom: DomService,
    private readonly pfs: ProfileService, private readonly router: Router,
    private readonly windowRef: WindowRef, private readonly navbar: NavbarService) {
  }

  ngOnInit(): void {
    const path = this.location.path();
    this.navbar.handleDirectLink(path);

    const id = this.navbar.getContextId(this.windowRef.getSearch());
    const type = this.navbar.getContextType(this.windowRef.getPathname());

    this.defaultTranslation$ = this.auth.getTranslation(environment.defaultLanguage).subscribe(tnl => {
      this.profile$ = this.auth.getProfile(type, id).subscribe(response => {
        if (Array.isArray(response)) {
          response = response[0];
        }
        this.pfs.profile = response;

        const language = this.pfs.getLanguage(environment.supportedLanguages,
          environment.defaultLanguage, this.pfs.profile.language);
        this.pfs.profile.language = language;

        this.userTranslation$ = this.auth.getTranslation(language).subscribe(result => {
          this.navbar.handleContextId(String(this.pfs.profile.id));
          this.pfs.messages = this.pfs.extend(tnl, result);
          this.dom.hideNoProfileSpinner();
          const sessionStoragePath = sessionStorage.getItem('adminUIPath');
          if (sessionStoragePath?.includes(PATH.tasks)) {
            this.router.navigateByUrl(sessionStoragePath);
          } else {
            const item = this.navbar.getProfileNavItem(this.pfs.profile, this.windowRef.getHostname());
            this.dom.setPageTitle(item.path);
            this.router.navigateByUrl(item.path);
          }
        });

      });
    });
  }

  ngOnDestroy(): void {
    this.defaultTranslation$.unsubscribe();
    this.profile$.unsubscribe();
    this.config$.unsubscribe();
    this.userTranslation$.unsubscribe();
  }
}




